// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create_folder_form-module__group--1mvp0{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.create_folder_form-module__input--3juOn{-webkit-box-flex:1;-webkit-flex:1 1 0px;-moz-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0px}.create_folder_form-module__error--seZRA{margin-bottom:8px}\n", ""]);
// Exports
exports.locals = {
	"group": "create_folder_form-module__group--1mvp0",
	"input": "create_folder_form-module__input--3juOn",
	"error": "create_folder_form-module__error--seZRA"
};
module.exports = exports;
